import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShareLocationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"share_location"}/>
}
